import {  
    SELECT_ACTIVITY,
    INVALIDATE_ACTIVITY,
    UPDATE_ANSWER, GET_ANSWER
  } from './actions'


  export function selectedActivity(state = '', action) {
    switch (action.type) {
      case SELECT_ACTIVITY:
        return action.activity
      case INVALIDATE_ACTIVITY:
        return null
//    case INVALIDATE_ASSESSMENT:
//        return null        
      default:
        return state
    }  
  }

export function dimensionAnswer(state ={}, action) {
  switch (action.type) {
    case GET_ANSWER: 
      return Object.assign({},state,{[action.id]: action.answer })
    default: 
      return state
  }
}



  
  
  export function updateAnswer(state = '' , action) {
      switch (action.type) {
        case UPDATE_ANSWER:
          return Object.assign({},action.assessment)
        default:
          return state
      }
    }  


// WEBPACK FOOTER //
// ./src/activities/reducers.js